import { Form, FormProps, Row, Col, Button, Divider, Empty, Alert } from "antd";
import { useState, useEffect } from "react";
import dayjs, { Dayjs } from "dayjs";
import ContaSelect, { IContaSelectProps } from "@/Components/Populados/Financeiro/Conta/ContaSelect";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import CarregamentoComponentes from "@/Components/Base/Carregamento";
import SaldoPeriodoTableBasic, { ISaldoPeriodoTableBasicProps } from "./SaldoPeriodoTableBasic";
import { useMovimentacaoSaldoPeriodoListar } from "@/Services/Domain/Relatorio/Financeiro/Conta/MovimentacaoSaldoPeriodo";
import InputRangePicker from "@/Components/Base/Input/InputRangePicker";
import Formatacoes from "@/Utils/Formatacao";
import { Balanco } from "@/Components/Balanco";
import { EnumTipoConta, TypeConta } from "@/Models/Financeiro/Conta";

export interface ISaldoPeriodoConsultaScreenFormType
{
    codConta:number;
    dataInicial:Date;
    dataFinal:Date;
    intervalo:[Dayjs,Dayjs]
}
export interface ISaldoPeriodoConsultaScreenProps extends FormProps<ISaldoPeriodoConsultaScreenFormType> {
    tableProps?:ISaldoPeriodoTableBasicProps;
    codContaTipo?:EnumTipoConta;
    intervaloObrigatorio ?: boolean;
    cabecalhoSaldoVisivel?: boolean;
    camposProps ?: {
        contaSelectProps ?:IContaSelectProps;
    }
}

export default function SaldoPeriodoConsultaScreen({
    form : formParam,
    intervaloObrigatorio,
    camposProps,
    codContaTipo,
    initialValues,
    component,
    cabecalhoSaldoVisivel,
    tableProps,
    layout,
    ...rest
}:ISaldoPeriodoConsultaScreenProps) {
    const dataAtual = new Date();
    const [newForm] = Form.useForm<ISaldoPeriodoConsultaScreenFormType>();
    const form = formParam ?? newForm;
    const paremetros = Form.useWatch([], form);
    //const [paremetros, setParametros] = useState<ISaldoPeriodoConsultaScreenFormType>({} as ISaldoPeriodoConsultaScreenFormType);

    const {
        isLoading,
        isSuccess,
        isError,
        refetch,
        data
    } = useMovimentacaoSaldoPeriodoListar({
        codConta : paremetros?.codConta,
        dataInicial : paremetros?.intervalo?.[0]?.toDate(),
        dataFinal : paremetros?.intervalo?.[1]?.toDate(),
        enabled : paremetros?.codConta > 0
    });

    return (
        <Form
            {...rest}
            form={form}
            size="small"
            component={component === undefined ? "div" : component}
            layout={layout === undefined ? "vertical" : layout}
            initialValues={{
                ...initialValues,
                intervalo: initialValues?.intervalo === undefined ? [dayjs(new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1)), dayjs(dataAtual)] : initialValues?.intervalo,
            }}
            onFinish={(data) => {
                refetch();
            }}
        >
            <Row gutter={8} wrap justify="left" align="bottom">
                <Col xs={24} sm={12} md={10} lg={8} xl={5} xxl={4}>
                    <Form.Item<ISaldoPeriodoConsultaScreenFormType> label="Conta" name={["codConta"]} rules={[{ required: true }]}>
                        <ContaSelect 
                            {...camposProps?.contaSelectProps}
                            filtros={{
                                ...camposProps?.contaSelectProps?.filtros,
                                conta : {
                                    ...camposProps?.contaSelectProps?.filtros?.conta,
                                    codTipoConta : codContaTipo
                                } as TypeConta
                            }} 
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={10} lg={8} xl={6} xxl={5}>
                    <Form.Item<ISaldoPeriodoConsultaScreenFormType> label="Intervalo" name={"intervalo"} rules={[{ required: intervaloObrigatorio ?? true }]}>
                        <InputRangePicker />
                    </Form.Item>
                </Col>
                <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}>
                    <Col xs={"auto"}>
                        <Form.Item<ISaldoPeriodoConsultaScreenFormType>>
                            <Button type="primary" loading={isLoading} onClick={() => form.submit()}>
                                Listar
                            </Button>
                        </Form.Item>
                    </Col>
                </ComponentePermissao>
            </Row>
            
            {((isSuccess || isLoading) && (
                <>
                    <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}>
                        <CarregamentoComponentes.TelaCarregamento ativo={isLoading || !!tableProps?.loading}>
                            <SaldoPeriodoTableBasic
                                {...tableProps}
                                dataSource={data?.detalhes}
                                _plus={{
                                    depoisDeDesativar: () => {
                                        refetch();
                                    }
                                }}
                                hideColumns={{
                                    ...tableProps?.hideColumns,
                                    enabled: tableProps?.hideColumns?.enabled ?? true,
                                    defaultHiddenKeys : tableProps?.hideColumns?.defaultHiddenKeys ?? []
                                }}
                                insertSubHeader={(cabecalhoSaldoVisivel ?? true) ? [
                                    {
                                        title: <>Data</>,
                                        data: [<> Até { Formatacoes.paraData(data?.dataInicial)?.toLocaleDateString()} </>],
                                        colSpan: 4,
                                    },
                                    {
                                        title: <> Saldo acumulado anterior </>,
                                        data: [<Balanco>{Formatacoes.formatarReal(data?.valorAnterior)}</Balanco>],
                                        colSpan: 4,
                                    },
                                ] : undefined}
                            />
                        </CarregamentoComponentes.TelaCarregamento>
                    </ComponentePermissao>
                </>
            )) || (
                <>
                    <Empty description={isError ? "Ocorreu um erro, tente novamente!" : 'Clique em "Listar" para realizar a consulta.'} />
                </>
            )}
        </Form>
    );
}